import comp from "./MagicLinkExpired";
export default comp;
